import {getAppSessionCookieHeader, handleSessionId} from "../appCookie";
import api from "../../Api";
import {handleError} from "../Utils";

export const getMenu = () => {
  return api.get('lookup/menu/' + getAppSessionCookieHeader());
}

export const getCustomerPurchaseGroupResponse = async (clientGuid, paymentIntent) => {
  const resp = await api.get('cart/sales/intent/' + clientGuid + '/' + paymentIntent + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getKioskPurchaseGroupResponse = async (paymentIntent) => {
  const resp = await api.get('cart/sales/intent/kiosk/' + paymentIntent + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const updateMemberPerkItem = async (clientGuid, item) => {
  return await api.post('cart/perk/item/' + clientGuid + getAppSessionCookieHeader(), item).then((response) => {
    return response.data;
  });
}

export const getCompanyDiscountCodes = async () => {
  const resp = await api.get('discount/codes' + getAppSessionCookieHeader())
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveCompanyMatrix = async (matrix)=> {
  const resp = await api.post('company/matrix/save' + getAppSessionCookieHeader(), matrix)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const getCompanyMatrixes = async () => {
  const resp = await api.get('company/matrix/get' + getAppSessionCookieHeader())
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const getCompanyPreferences = async () => {
  const resp = await api.get('preferences/company' + getAppSessionCookieHeader())
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const saveCompanyPreferences = async (prefs) => {
  const resp = await api.post('preferences/company' + getAppSessionCookieHeader(), prefs)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}


export const saveCompanyDiscountCode = async (item) => {
  return await api.post('discount/code'  + getAppSessionCookieHeader(), item).then((response) => {
    return response.data;
  });
}

export const saveCompanyDiscountCodeTokens = async (item) => {
  return await api.post('discount/code/tokens'  + getAppSessionCookieHeader(), item).then((response) => {
    return response.data;
  });
}


export const archiveCompanyMatrix = async (item) => {
  return await api.post('company/matrix/archive'  + getAppSessionCookieHeader(), item).then((response) => {
    return response.data;
  });
}

export const archiveCompanyDiscountCode = async (item) => {
  return await api.post('discount/code/archive'  + getAppSessionCookieHeader(), item).then((response) => {
    return response.data;
  });
}

export const getCompanyDiscountCodeTypes = async () => {
  const resp = await api.get('discount/code/types' + getAppSessionCookieHeader())
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const getCompanyDiscountCode = async (guid) => {
  const resp = await api.get('discount/code/' + guid + getAppSessionCookieHeader())
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const getCompanyNotifications = async (dateQuery) => {
  const resp = await api.get('client/notifications/' + dateQuery + getAppSessionCookieHeader())
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const getSessionUser = async (isClient, ref) => {
  const resp = await api.get('auth/user' + (isClient ? '/cx?___ref=' + ref : '') + getAppSessionCookieHeader())
    .then((response) => {
      handleSessionId(response);
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const uploadCompanyLogo = async (data) => {
  const resp = await api.post('company/logo/save' + getAppSessionCookieHeader(), data).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;

}

export const uploadTemplateFile = async (data) => {
  const resp = await api.post('company/templates/file/upload' + getAppSessionCookieHeader(), data).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;

}

export const assumeIdentity = async (guid) => {
  const resp = await api.get('admin/company/employee/assume/' + guid + getAppSessionCookieHeader()).then((response) => {
    handleSessionId(response);
    return response.data;
  });
  return resp;
}

export const dropIdentity = async (guid) => {
  const resp = await api.get('admin/company/employee/drop' + getAppSessionCookieHeader()).then((response) => {
    handleSessionId(response);
    return response.data;
  });
  return resp;
}

export const login = async (auth) => {
  const resp = await api.post('auth/login' + getAppSessionCookieHeader(), auth).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


export const checkPassResetExpiration = async (tokenGuid) => {
  const resp = await api.get('auth/pass/reset/expiration/' + tokenGuid + getAppSessionCookieHeader()).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const resetPass = async (auth) => {
  const resp = await api.post('auth/pass/reset' + getAppSessionCookieHeader(), auth).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const resetPassConfirm = async (auth) => {
  const resp = await api.post('auth/pass/reset/confirm' + getAppSessionCookieHeader(), auth).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const addSquarePayment = async (guid) => {
  const resp = await api.get('client/add/payment/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCustomerFamily = async (guid) => {
  const resp = await api.get('client/family/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCustomerFamilyAll = async (guid) => {
  const resp = await api.get('client/family/all/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCustomer = async (guid) => {
  const resp = await api.get('client/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const processRefund = async (refundItem) => {
  const resp = await api.post('client/sales/refund' + getAppSessionCookieHeader(), refundItem).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getSaleItem = async (guid) => {
  const resp = await api.get('client/sales/item/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const archiveSalesItem = async (refundItem) => {
  const resp = await api.post('client/sales/archive' + getAppSessionCookieHeader(), refundItem).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCompanyNotes = async (guid) => {
  const resp = await api.get('admin/company/notes/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveCompanyNote = async (note) => {
  const resp = await api.post('admin/company/notes/save' + getAppSessionCookieHeader(), note).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCompany = async (guid) => {
  const resp = await api.get('admin/company/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


export const getMyProfile = async () => {
  const resp = await api.get('client/my/profile' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


export const syncCompanyExtAppTerminal = async (extApp) => {
  const resp = await api.post('company/ext/app/pos/sync' + getAppSessionCookieHeader(), extApp).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const createCompanyExtAppTerminal = async (extApp) => {
  const resp = await api.post('company/ext/app/pos' + getAppSessionCookieHeader(), extApp).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveHomeLocation = async (extApp) => {
  const resp = await api.post('company/ext/app/home' + getAppSessionCookieHeader(), extApp).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveEmployeeHomeLocation = async (guid, extApp) => {
  const resp = await api.post('company/ext/employee/home/' + guid + getAppSessionCookieHeader(), extApp).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCompanyExtApp = async () => {
  const resp = await api.get('company/ext/app' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const connectCompanyExtApp = async () => {
  const resp = await api.get('company/connect/ext/app' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getMyCompanyAuth = async () => {
  const resp = await api.get('auth/company' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getMyCompany = async () => {
  const resp = await api.get('company/' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCompanyEmployees = async (guid) => {
  const resp = await api.get('admin/company/employees/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getMyCompanyEmployees = async () => {
  const resp = await api.get('company/employees' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCompanyVendors = async () => {
  const resp = await api.get('company/vendors/list' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveCompanyForm = async (formData) => {
  const resp = await api.post('form/save' + getAppSessionCookieHeader(), formData).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const removeCompanyForm = async (formData) => {
  const resp = await api.post('form/remove' + getAppSessionCookieHeader(), formData).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveFormQuestion = async (questionData) => {
  const resp = await api.post('form/question' + getAppSessionCookieHeader(), questionData).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const deleteFormQuestion = async (questionData) => {
  const resp = await api.post('form/question/remove' + getAppSessionCookieHeader(), questionData).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getQuestionTypes = async () => {
  const resp = await api.get('form/questionTypes' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveCafeGroupMember = async (group, item) => {
  const resp = await api.post('cafe/group/member/save/' + group.optionGroupGuid + getAppSessionCookieHeader(), item).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const removeCafeGroupMember = async (group, item) => {
  const resp = await api.post('cafe/group/member/remove/' + group.optionGroupGuid + getAppSessionCookieHeader(), item).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveCafeOptionGroup = async (formData) => {
  const resp = await api.post('cafe/optionGroup/save' + getAppSessionCookieHeader(), formData).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


export const archiveCafeOptionGroup = async (option) => {
  const resp = await api.post('cafe/optionGroup/remove' + getAppSessionCookieHeader(), option).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const archiveCafeOption = async (option) => {
  const resp = await api.post('cafe/option/remove' + getAppSessionCookieHeader(), option).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCafeOrderStatuses = async () => {
  const resp = await api.get('cafe/orderStatuses' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const updateCafeOrder = async (order) => {
  const resp = await api.post('cafe/order' + getAppSessionCookieHeader(), order).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCafeFulfilledOrders = async () => {
  const resp = await api.get('cafe/orders/fulfilled' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const pollAsyncEvents = async (pollId) => {
  const resp = await api.get('inventory/events/poll/' + pollId + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCafeOrders = async () => {
  const resp = await api.get('cafe/orders' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCafeOptionGroups = async () => {
  const resp = await api.get('cafe/optionGroups' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCafeOptionItems = async () => {
  const resp = await api.get('cafe/options' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getOptionGroup = async (groupGuid) => {
  const resp = await api.get('cafe/group/' + groupGuid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveCafeOptionItem = async (optionGroupGuid, optionItemData) => {
  const resp = await api.post('cafe/option/' + optionGroupGuid + getAppSessionCookieHeader(), optionItemData).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCompanyForms = async () => {
  const resp = await api.get('form/forms' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


export const getCompanyQuestions = async () => {
  const resp = await api.get('form/questions' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


export const getMyCompanyEmployee = async (guid) => {
  const resp = await api.get('company/employee/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getEmployeeTimecard = async (timecardRequest) => {
  const resp = await api.post('company/employee/timecard' + getAppSessionCookieHeader(), timecardRequest).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getEmployeeSchedule = async (timecardRequest) => {
  const resp = await api.post('company/employee/schedule' + getAppSessionCookieHeader(), timecardRequest).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCalendarSchedule = async (timecardRequest) => {
  const resp = await api.post('company/employee/calendar' + getAppSessionCookieHeader(), timecardRequest).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCompanyTimecard = async (timecardRequest) => {
  const resp = await api.post('company/full/timecard' + getAppSessionCookieHeader(), timecardRequest).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveEmployeeTimeEntry = async (timecardRequest) => {
  const resp = await api.post('company/employee/timeentry' + getAppSessionCookieHeader(), timecardRequest).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const archiveEmployeeTimeEntry = async (timecardRequest) => {
  const resp = await api.post('company/archive/timeentry' + getAppSessionCookieHeader(), timecardRequest).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveCommunicationTemplate = async (template) => {
  const resp = await api.post('company/template/save' + getAppSessionCookieHeader(), template).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const sendEmail = async (email) => {
  const resp = await api.post('company/email/send' + getAppSessionCookieHeader(), email).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const archiveCompanyWaiver = async (waiver) => {
  const resp = await api.post('company/waiver/archive/' + waiver.guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


export const getRecentCompanyWaivers = async (eventDate) => {
  const resp = await api.post('company/waivers/list' + getAppSessionCookieHeader(), {
    startDate : eventDate
  }).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveCompanyWaiver = async (waiver) => {
  const resp = await api.post('company/waiver/save' + getAppSessionCookieHeader(), waiver).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getPublicCompanyWaiverList = async () => {
  const resp = await api.get('company/waiver/public' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const removeCompanyEmailCredential = async () => {
  const resp = await api.post('company/credential/email/remove' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const sendTestCredentialEmail = async (credential) => {
  const resp = await api.post('company/credential/email/test' + getAppSessionCookieHeader(), credential).then((response) => {
    return response.data;
  });
  return resp;
}

export const saveCredentialEmail = async (credential) => {
  const resp = await api.post('company/credential/email/save' + getAppSessionCookieHeader(), credential).then((response) => {
    return response.data;
  });
  return resp;
}

export const saveCompanyExtCredential = async (credential) => {
  const resp = await api.post('company/credential/save' + getAppSessionCookieHeader(), credential).then((response) => {
    return response.data;
  });
  return resp;
}

export const getCompanyCredentials = async () => {
  const resp = await api.get('company/credentials' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCompanyWaiverList = async () => {
  const resp = await api.get('company/waiver/list' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCompanyWaiver = async (guid) => {
  const resp = await api.get('company/waiver/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCommunicationTemplates = async () => {
  const resp = await api.get('company/templates/list' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getEventTemplates = async () => {
  const resp = await api.get('company/event/templates/list' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCommunicationTemplate = async (guid) => {
  const resp = await api.get('company/templates/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const massEmail = async (req) => {
  const resp = await api.post('mass/email/send' + getAppSessionCookieHeader(), req).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const massTags = async (req) => {
  const resp = await api.post('mass/tags/save' + getAppSessionCookieHeader(), req).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const recordCustomerVisit = async (guid, reservation) => {
  const resp = await api.post('client/visit/' + guid + getAppSessionCookieHeader(), reservation)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });

  return resp;
}

export const getClientMemberPerks = async (guid) => {
  const resp = await api.get('perk/perks/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getVisits = async (guid) => {
  const resp = await api.get('client/visits/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getReservations = async (guid) => {
  const resp = await api.get('client/reservations/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getClientNotes = async (guid) => {
  const resp = await api.get('client/notes/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getInventoryNotes = async (guid) => {
  const resp = await api.get('inventory/notes/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getFamilyMemberTypes = async () => {
  const resp = await api.get('lookup/familyMemberTypes' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;

}

export const getStates = async () => {
  const resp = await api.get('lookup/states' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


export const getCredentialTypes = async () => {
  const resp = await api.get('lookup/credentialtypes' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


export const getTimeZones = async () => {
  const resp = await api.get('lookup/timeZones' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const searchUsername = async (searchParams, searchIndex) => {
  const resp = await api.post('company/username' + getAppSessionCookieHeader(), searchParams).then((response) => {
    let _resp = {searchIndex: searchIndex, resp: response.data}
    return _resp;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const adminSearchCompanyName = async (searchParams, searchIndex) => {
  const resp = await api.post('admin/company/name' + getAppSessionCookieHeader(), searchParams).then((response) => {
    let _resp = {searchIndex: searchIndex, resp: response.data}
    return _resp;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const adminSaveCompanyMemberships = async (req) => {
  const resp = await api.post('admin/company/memberships/assign' + getAppSessionCookieHeader(), req).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });
  return resp;
}

export const adminGetCompanyMemberships = async (company) => {
  const resp = await api.post('admin/company/memberships' + getAppSessionCookieHeader(), company).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });
  return resp;
}

export const adminSearchCompanySubdomain = async (searchParams, searchIndex) => {
  const resp = await api.post('admin/company/subdomain' + getAppSessionCookieHeader(), searchParams).then((response) => {
    let _resp = {searchIndex: searchIndex, resp: response.data}
    return _resp;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const adminSearchCompanyContext = async (searchParams, searchIndex) => {
  const resp = await api.post('admin/company/context' + getAppSessionCookieHeader(), searchParams).then((response) => {
    let _resp = {searchIndex: searchIndex, resp: response.data}
    return _resp;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const searchContext = async (searchParams, searchIndex) => {
  const resp = await api.post('client/context' + getAppSessionCookieHeader(), searchParams).then((response) => {
    let _resp = {searchIndex: searchIndex, items: response.data}
    return _resp;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const searchCustomers = async (searchParams, searchIndex) => {
  const resp = await api.post('client/search' + getAppSessionCookieHeader(), searchParams).then((response) => {
    let _resp = {searchIndex: searchIndex, customers: response.data}
    return _resp;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const searchOrganizationCustomers = async (searchParams, searchIndex) => {
  const resp = await api.post('client/org/search' + getAppSessionCookieHeader(), searchParams).then((response) => {
    let _resp = {searchIndex: searchIndex, customers: response.data}
    return _resp;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const searchCompanies = async (searchParams) => {
  const resp = await api.post('admin/company/search' + getAppSessionCookieHeader(), searchParams).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getPublicReleaseNotes = async () => {
  const resp = await api.get('company/release/notes' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const adminGetReleaseNotes = async () => {
  const resp = await api.get('admin/company/release/notes' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const adminSaveRelease = async (release) => {
  const resp = await api.post('admin/company/release/version' + getAppSessionCookieHeader(), release).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const adminConvertInvoice = async (release) => {
  const resp = await api.post('admin/company/invoice/convert' + getAppSessionCookieHeader(), release).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const adminSaveReleaseItem = async (releaseItem) => {
  const resp = await api.post('admin/company/release/item' + getAppSessionCookieHeader(), releaseItem).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const adminArchiveRelease = async (release) => {
  const resp = await api.post('admin/company/release/archive' + getAppSessionCookieHeader(), release).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const adminPublishRelease = async (release) => {
  const resp = await api.post('admin/company/release/publish' + getAppSessionCookieHeader(), release).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const removeClientTag = async (tag) => {
  return await api.post('client/tag/remove' + getAppSessionCookieHeader(), tag).then((response) => {
    return response.data;
  });
}

export const removeClientPerk = async (perk) => {
  return await api.post('perk/remove' + getAppSessionCookieHeader(), perk).then((response) => {
    return response.data;
  });
}

export const sendInvoiceReminderMessage = async (invoice) => {
  return await api.post('client/invoice/reminder' + getAppSessionCookieHeader(), invoice).then((response) => {
    return response.data;
  });
}

export const saveClientTag = async (tag) => {
  return await api.post('client/tag' + getAppSessionCookieHeader(), tag).then((response) => {
    return response.data;
  });
}

export const saveGuestCustomer = async (customer) => {
  const resp = await api.post('client/guest/merge' + getAppSessionCookieHeader(), customer).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveGuestCheckIn = async (guest) => {
  const resp = await api.post('client/guest/checkIn' + getAppSessionCookieHeader(), guest).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


export const saveCustomer = async (customer) => {
  const resp = await api.post('client/save' + getAppSessionCookieHeader(), customer).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const pauseEmail = async (customer) => {
  const resp = await api.post('client/pause' + getAppSessionCookieHeader(), customer).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const unpauseEmail = async (customer) => {
  const resp = await api.post('client/unpause' + getAppSessionCookieHeader(), customer).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


export const previewGuestWaiver = async (waiverGuid) => {
  const resp = await api.get('client/waiver/preview/guest/' + waiverGuid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getGuestWaiver = async (waiverGuid) => {
  const resp = await api.get('client/waiver/download/guest/' + waiverGuid + getAppSessionCookieHeader(),
    {
      responseType: 'blob',
    }).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const previewClientWaiver = async (customer, waiverGuid) => {
  const resp = await api.get('client/waiver/preview/' + customer.guid + '/' + waiverGuid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getClientWaiver = async (customer, waiverGuid) => {
  const resp = await api.get('client/waiver/download/' + customer.guid + '/' + waiverGuid + getAppSessionCookieHeader(),
    {
      responseType: 'blob',
    }).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveClientBilling = async (clientBilling) => {
  const resp = await api.post('client/billing' + getAppSessionCookieHeader(), clientBilling).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveClientAccount = async (account) => {
  const resp = await api.post('client/account' + getAppSessionCookieHeader(), account).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveClientAccountStartDate = async (account) => {
  const resp = await api.post('client/account/start/date' + getAppSessionCookieHeader(), account).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const deleteClientNote = async (note) => {
  const resp = await api.post('client/note/delete' + getAppSessionCookieHeader(), note).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });
  return resp;
}

export const deleteInventoryNote = async (note) => {
  const resp = await api.post('inventory/note/delete' + getAppSessionCookieHeader(), note).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });
  return resp;
}

export const saveClientNote = async (note) => {
  const resp = await api.post('client/note' + getAppSessionCookieHeader(), note).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const sendClientSms = async (message) => {
  const resp = await api.post('client/sms' + getAppSessionCookieHeader(), message).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveEventNote = async (note) => {
  const resp = await api.post('inventory/note' + getAppSessionCookieHeader(), note).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveMoveEventReservation = async (request) => {
  const resp = await api.post('inventory/event/registration/move' + getAppSessionCookieHeader(), request).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveClientReservation = async (client, reservation) => {
  const resp = await api.post('client/reservation/' + client.guid + getAppSessionCookieHeader(), reservation).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const cancelClientReservation = async (reservation) => {
  const resp = await api.post('client/reservation/cancel' + getAppSessionCookieHeader(), reservation).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const noShowClientReservation = async (reservation) => {
  const resp = await api.post('client/reservation/noshow' + getAppSessionCookieHeader(), reservation).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const checkOutClientReservation = async (reservation) => {
  const resp = await api.post('client/reservation/checkout' + getAppSessionCookieHeader(), reservation).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const cancelClientWaitlist = async (reservation) => {
  const resp = await api.post('client/waitlist/cancel' + getAppSessionCookieHeader(), reservation).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


export const savePrimaryClientBilling = async (client, billingGuid) => {
  const resp = await api.post('client/billing/primary/' + billingGuid + getAppSessionCookieHeader(), client)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });

  return resp;
}

export const deleteCustomerBilling = async (client, billing) => {
  return await api.post('client/billing/delete/' + client.guid + '/' + billing.guid);
}

export const deleteCustomerInvoice = async (client, invoice) => {
  return await api.post('client/invoice/delete/' + client.guid + '/' + invoice.invoiceGuid);
}

export const deleteCustomerInvoiceGroup = async (client, invoice) => {
  return await api.post('client/invoice/group/delete/' + client.guid + '/' + invoice.invoiceGroupGuid);
}

export const mergeCustomerInvoices = async (mergeRequest) => {
  return await api.post('client/invoices/merge', mergeRequest);
}

export const saveCustomerInvoice = async (invoice) => {
  return await api.post('client/invoice/save', invoice);
}

export const getCustomerInvoice = async (clientGuid, invoiceGuid) => {
  const resp = await api.get('client/invoice/'+ clientGuid + '/' + invoiceGuid).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


export const removeCustomerInvoiceItem = async (invoice) => {
  return await api.post('client/invoice/item/remove', invoice);
}

export const deleteCustomerFamily = async (client, familyMember) => {
  return await api.post('client/family/delete/' + client.guid + '/' + familyMember.guid);
}

export const deleteEmployee = async (employee) => {
  return await api.post('company/employee/delete/' + employee.guid);
}

export const deleteCustomerMembership = async (client, membership) => {
  return await api.post('client/membership/delete/' + client.guid + '/' + membership.guid);
}

export const cancelCustomerMembership = async (client, membership) => {
  return await api.post('client/membership/cancel/' + client.guid + '/' + membership.guid);
}


export const deleteCustomer = async (client) => {
  return await api.post('client/delete/' + client.guid);
}

export const restoreCustomer = async (client) => {
  return await api.post('client/restore/' + client.guid);
}

export const saveMyCompany = async (company) => {
  const resp = await api.post('company/save' + getAppSessionCookieHeader(), company).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveMyCompanyTemplates = async (template) => {
  const resp = await api.post('company/templates/save' + getAppSessionCookieHeader(), template).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveMyCompanyStripeSettings = async (company) => {
  const resp = await api.post('company/stripe/save' + getAppSessionCookieHeader(), company).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveMyCompanySquareSettings = async (company) => {
  const resp = await api.post('company/square/save' + getAppSessionCookieHeader(), company).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveCompany = async (company) => {
  const resp = await api.post('admin/company/save' + getAppSessionCookieHeader(), company).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveArchiveCompany = async (company) => {
  const resp = await api.post('admin/company/archive' + getAppSessionCookieHeader(), company).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCompanyBillTypes = async () => {
  const resp = await api.get('admin/company/billingTypes' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveCompanyBranding = async (company, headerFooter) => {
  const resp = await api.post('company/branding/save/' + headerFooter + getAppSessionCookieHeader(), company).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getCompanyTasks = async (taskDate) => {
  const resp = await api.get('company/tasks/' + taskDate + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });


  return resp;
}

export const getMemberTabs = async () => {
  const resp = await api.get('cart/open/tabs' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });
  return resp;
}

export const completeTask = async (task) => {
  const resp = await api.post('company/task/complete' + getAppSessionCookieHeader(), task).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });


  return resp;
}

export const saveEmployee = async (employee) => {
  const resp = await api.post('company/employee/save' + getAppSessionCookieHeader(), employee).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const saveVendor = async (vendor) => {
  const resp = await api.post('company/vendors/save' + getAppSessionCookieHeader(), vendor).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const archiveVendor = async (vendor) => {
  return await api.post('company/vendors/archive/' + vendor.guid);
}

export const logout = async () => {
  const resp = await api.post('auth/logout' + getAppSessionCookieHeader()).then((response) => {
    return getSessionUser();
  });
  return resp;
}

export const switchLocation = async (req) => {
  const resp = await api.post('auth/switch/company' + getAppSessionCookieHeader(), req).then((response) => {
    return getSessionUser();
  });
  return resp;
}

export const saveAssignCartMembershipMembers = async (client, cartMembers) => {
  return await api.post('cart/membership/update/' + client.guid + getAppSessionCookieHeader(), cartMembers).then((response) => {
    return response.data;
  });
}

export const saveClientAccountMembershipMembers = async (account) => {
  return await api.post('client/membership/members' + getAppSessionCookieHeader(), account).then((response) => {
    return response.data;
  });
}

export const updateCartItem = async (cartItem) => {
  return await api.post('cart/item/update' + getAppSessionCookieHeader(), cartItem).then((response) => {
    return response.data;
  });
}

export const applyCartDiscountCodeItem = async (guid, cartItem) => {
  let urlPart = 'cart/discount/code';
  if (guid) {
    urlPart = urlPart + '/' + guid;
  }
  return await api.post(urlPart + getAppSessionCookieHeader(), cartItem).then((response) => {
    return response.data;
  });
}

export const removeMemberPerkItem = async (clientGuid, discountItemGuid, item) => {
  return await api.post('cart/perk/remove/' + clientGuid + '/' + discountItemGuid + getAppSessionCookieHeader(), item).then((response) => {
    return response.data;
  });
}

export const removeCartItem = async (cartItem) => {
  return await api.post('cart/remove' + getAppSessionCookieHeader(), cartItem).then((response) => {
    return response.data;
  });
}

export const logoutCustomer = async () => {
  const resp = await api.post('auth/logout' + getAppSessionCookieHeader()).then((response) => {
    return response;
  });
  return resp;
}


